module.exports = __webpack_public_path__ + "static/media/Image 98@2x.73cc5dd0.png";